import {
  BarChart3,
  Compass,
  LayoutGrid,
  type LucideIcon,
  Mail,
  Package,
  PlusCircle,
  Settings,
  ShieldCheck,
  Users,
} from "lucide-react";
import { canContribute, canGovern, type Role } from "@/lib/roles";

interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  /** Render a count pill resolved at display time (e.g. published-skill count). */
  count?: "published";
  /** External/legacy deep link rendered with reduced chrome. */
  legacy?: boolean;
}

interface NavGroup {
  title: string;
  items: NavItem[];
}

const DISCOVER: NavGroup = {
  title: "Discover",
  items: [
    { label: "Discover", href: "/", icon: Compass },
    { label: "All Skills", href: "/skills", icon: LayoutGrid, count: "published" },
  ],
};

const CONTRIBUTE: NavGroup = {
  title: "Contribute",
  items: [
    { label: "Submit a Skill", href: "/submit", icon: PlusCircle },
    { label: "My Skills", href: "/my-skills", icon: Package },
  ],
};

const GOVERN: NavGroup = {
  title: "Govern",
  items: [
    { label: "Moderation", href: "/moderation", icon: ShieldCheck },
    { label: "Analytics", href: "/analytics", icon: BarChart3 },
    { label: "User management", href: "/dashboard/settings/users", icon: Users, legacy: true },
    { label: "Email settings", href: "/dashboard/settings/email", icon: Mail, legacy: true },
    { label: "System", href: "/dashboard/settings/system", icon: Settings, legacy: true },
  ],
};

export function navGroupsForRole(role: Role): NavGroup[] {
  const groups: NavGroup[] = [DISCOVER];
  if (canContribute(role)) groups.push(CONTRIBUTE);
  if (canGovern(role)) groups.push(GOVERN);
  return groups;
}
